
/** 
 * A generic representation of an object in the database. Used when displaying
 * relations between objects without needing to get too specific 
 */
export class Subject {
	
	/** The unique identifier of this subject */
	public id: string;
	
	/** The name to display for this subject */
	public name: string;

	public displayName: string;

	/** Creates an instance of this object. */
	constructor(init?: Partial<Subject>) {
		Object.assign(this, init);
	}


}
